

export default class RegistrationOperations {
  
  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }
  
  contains(name) {
    if (name) {
      //
    }
    return true;
  }
  
  
  list(params = {}) {
    var event = RegistrationOperations.List.Operation(params);
    return this.eventsDomain.initRequest(event);
  }
  
  save(params = {}) {
    var event = RegistrationOperations.Save.Operation(params);
    return this.eventsDomain.initRequest(event);
  }

  create(params = {}) {
    var event = RegistrationOperations.Create.Operation(params);
    return this.eventsDomain.initRequest(event);
  }
  
  static Save = {
    Names: {
      Request: 'RegistrationSaveRequestEvent',
      Response: 'RegistrationSaveResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function(params = {}) {
      var request = {
        handler: RegistrationOperations.Save.Names.Request,
        eventName: RegistrationOperations.Save.Names.Request,
      };
      request["Params"] = params.data ? params.data : params;
      return request;
    },
  }

  
  static List = {
    Names: {
      Operation: 'RegistrationListRequestEvent',
      Notification: 'RegistrationListResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function(params = {}) {
      const event = {
          eventName: RegistrationOperations.List.Names.Operation,
          handler: RegistrationOperations.List.Names.Operation,
      };
      event["Params"] = params.data ? params.data : params;
      return event;
    },
  }
 
  static Create = {
    Names: {
      Operation: 'RegistrationCreateCompanyRequestEvent',
      Notification: 'RegistrationCreateCompanyResponseEvent',
    },

    Errors: {
      NotFound: {
        id: 'NotFound',
        msg: 'NotFound',
        details: ''
      },
    },

    Operation: function(params = {}) {
      var request = {
        handler: RegistrationOperations.Create.Names.Operation,
        eventName: RegistrationOperations.Create.Names.Operation,
      };
      request["Params"] = params.data ? params.data : params;
      return request;
    },
  }
}